import GDPRSettingsStorage from "@weseus/cms-core/assets/js/front/GDPRSettingsStorage"
import naja from 'naja'
import GDPRSettingsExtension from "@weseus/cms-core/assets/js/front/GDPRSettings.naja"

naja.registerExtension(GDPRSettingsExtension);

export default function initCookiesBox() {
	const boxElem = document.querySelector('#cookies-box');
	const gdprSettings = new GDPRSettingsStorage();

	document.addEventListener('click', function (ev) {
		if (ev.target.id === 'cookie-allow_all') {
			ev.preventDefault();

			gdprSettings.save(['functional', 'statistics', 'marketing']);

			document.dispatchEvent(new CustomEvent('cookies-box.save'));

			boxElem.classList.add('d-none');
		}

		if (ev.target.id === 'cookie-deny_all') {
			ev.preventDefault();

			gdprSettings.save(['functional']);

			document.dispatchEvent(new CustomEvent('cookies-box.save'));

			boxElem.classList.add('d-none');
		}
	});

	if (boxElem) {
		boxElem.classList.toggle('d-none', gdprSettings.has());

		let form = boxElem.querySelector('form');
		if (form) {
			let allowedCookies = gdprSettings.load();

			const checkboxes = form.querySelectorAll('input[type=checkbox]');
			if (allowedCookies.length > 0) {
				checkboxes.forEach((input) => {
					if (allowedCookies.includes(input.getAttribute('name'))) {
						input.checked = true;
					}
				});
			}

			form.addEventListener('submit', (e) => {
				e.preventDefault();

				const data = new FormData(e.target);
				let allowed = ['functional'];

				data.forEach((val, name) => {
					if (val === 'on') {
						allowed.push(name);
					}
				});

				gdprSettings.save(allowed);

				document.dispatchEvent(new CustomEvent('cookies-box.save'));

				boxElem.classList.add('d-none');
			});
		}

	}
}